import httpsV2 from '../../config/httpsV2'

export const getAllCountries = (lang) => {
  return httpsV2.get(`/middleware/countries?lang=${lang}`)
}
